// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f1a819d2","453":"efe365b0","455":"eaf9bc17"}[chunkId] + ".chunk.js";
};